import APIArticles from "@/api/modules/articles";

const state = () => ({
  articlesList: [],
  articlesTotal: 0,
  article: null,
  tags: [],
  users: [],
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getArticles({ commit }, params) {
      return APIArticles.getArticles(params).then((response) => {
        if (!response || !response.data) return;

        const data = response.data;
        const list = Array.isArray(data) ? data : data.articles || [];
        const meta = (!Array.isArray(data) && data.meta) || {};
        const headerTotal = parseInt(
          (response.headers && response.headers["x-pagination-total-count"]) || "",
          10
        );
        const total = Number(meta.total_count)
          || (!Number.isNaN(headerTotal) && headerTotal)
          || list.length;

        commit("SET_DATA", { type: "articlesList", data: list });
        commit("SET_DATA", { type: "articlesTotal", data: total });
      });
    },
    getArticle({ commit }, { lang, alias }) {
      return APIArticles.getArticle(lang, alias).then((response) => {
        if (response && response.data) {
          commit("SET_DATA", {
            type: "article",
            data: response.data.article || response.data,
          });
        }
      });
    },
    upsertArticle(_, data) {
      return APIArticles.upsertArticle(data);
    },
    deleteArticle(_, { lang, alias }) {
      return APIArticles.deleteArticle(lang, alias);
    },
    translateArticle(_, { lang, alias, targetLocales }) {
      return APIArticles.translateArticle(lang, alias, targetLocales);
    },
    getTags({ commit }) {
      return APIArticles.getTags().then((response) => {
        if (response && response.data) {
          const tags = Array.isArray(response.data) ? response.data : response.data.tags || [];
          commit("SET_DATA", { type: "tags", data: tags });
        }
      });
    },
    getUsers({ commit }) {
      return APIArticles.getUsers().then((response) => {
        if (response && response.data) {
          commit("SET_DATA", {
            type: "users",
            data: Array.isArray(response.data) ? response.data : [],
          });
        }
      });
    },
  },
};
